import { MdOutlineError } from "react-icons/md";
import useGetLanguage from "../../../utils/useGetLanguage";
import { LanguageText } from "../../../dictionary/GroupNotificationText";

type NotificationNameProps = {
  name: string;
  onChange: (val: string) => void;
  error: boolean;
};
const NotificationName = ({
  name,
  onChange,
  error,
}: NotificationNameProps): React.JSX.Element => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupNotificationText",
  });

  return (
    <div className="mb-6 bg-gray-100 p-10 rounded-lg mt-2">
      <input
        className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
        type="text"
        value={name}
        onChange={(event) => onChange(event.target.value)}
        placeholder={Language?.name}
        required
      />
      {error && (
        <div className="flex items-center mt-3">
          <MdOutlineError className="text-red-500 text-lg mr-2" />
          <span className="text-xs text-red-500">{Language?.nameError}</span>
        </div>
      )}
    </div>
  );
};

export default NotificationName;
